<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl"
      withoutDelete>
    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      :filter="scopedFilterData"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.scopedFilterData.departmentId = this.userDepartmentId
    this.scopedFilterData.sourceDepartmentId = this.userDepartmentId
  },
  data() {
    return {
      apiUrl: '/logistic-distribution',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'DateSent', label: 'Tanggal', formatter: value => this.$helper.formatDateTime(value) },
        { key: 'LogisticEntryTransaction', label: 'Barang', formatter: value => value ? value.LogisticItem.Name : '' },
        // { key: 'SourceDistribution', label: 'Asal Ruang', formatter: value => value.LogisticEntryTransaction.Department.Name },
        { key: 'Department', label: 'Ruang Tujuan', formatter: value => value ? value.Name : '' },
        { key: 'Quantity', label: 'Jumlah' },
        { key: 'SenderUser', label: 'Pengirim', formatter: value => {
          return value ? value.Employee.Name : ''
        }},
        { key: 'ReceiverUser', label: 'Penerima', formatter: value => {
          return value ? value.Employee.Name : ''
        }},
        { key: 'LogisticDistributionStatus', label: 'Status', formatter: value => {
          if (!value) return
            
          if (value.Restrict === 1) {
            return `<span class="badge badge-success">${value.Name}</span>`
          } else {
            return `<span class="badge badge-danger">${value.Name}</span>`
          }
        }}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {},
      scopedDetailData: {},
      scopedFilterData: {
        departmentId: null,
        sourceDepartmentId: null
      }
    }
  },
  computed: {
    userDepartmentId () {
      return this.$store.getters['user/userDepartment'].ID
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    // loadOptionData () {
    //   this.$axios.get('/department').then((res) => {
    //     this.listDepartments = res.data
    //   })
    // },
    // loadOptionData () {
    //   this.$axios.get('/logistic-supplier').then((res) => {
    //     this.listLogisticSuppliers = res.data
    //   })
    // }
  }
}
</script>
